<nav class="navbar navbar-light bg-white">
  <div class="container-xxl px-2 px-md-4 px-lg-5 py-0 py-md-0 py-lg-0">
    <!--<div class=" px-2 px-md-4">-->
    <div class="d-flex align-items-center justify-content-between w-100">
      <!-- Left Section: Logo + Separator + Title -->
      <div class="d-flex align-items-center flex-shrink-1 min-w-0">
        <!-- Vanguard Logo -->

        <img src="/images/vanguard-logo.svg" alt="Vanguard Logo"
             class="logo-desktop d-none d-md-block navbar-brand me-2 me-md-3 mb-0 flex-shrink-0">
        <img src="/images/vanguard-mobile-logo.svg" alt="Vanguard Logo"
             class="logo-mobile d-md-none navbar-brand me-2 me-md-3 mb-0 flex-shrink-0">

        <!-- Separator (hidden on mobile) -->
        <div class="vw-separator"></div>

        <!-- Page Title (Desktop) -->
        <h1 class="navbar-title c11n-text-lg mb-0 ms-2 ms-md-3 d-none d-md-block text-nowrap">Statement messaging</h1>

        <!-- Page Title (Mobile) -->
        <h1 class="navbar-title-mobile mb-0 d-md-none ms-2 text-truncate">Statement messaging</h1>
      </div>

      <!-- Right Section: Logout Link -->
      <div class="navbar-nav flex-shrink-0 ms-2">
        <ng-container *ngIf="showSignOut; else loginButton">
          <button
            c11n-link
            [variant]="'secondary-reinforced'"
            class="nav-logout-btn"
            [fontWeight]="'bold'"
            (click)="performLogout()"
            aria-label="Log out">
            Log out
          </button>
        </ng-container>

        <!-- Render login button if user is signed out -->
        <ng-template #loginButton>
          <button
            c11n-link
            [variant]="'secondary-reinforced'"
            class="nav-logout-btn"
            [fontWeight]="'bold'"
            (click)="performOktaLogin()"
            aria-label="Log in">
            Log in
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</nav>
